@let tooltip = tooltipKey | transloco: { label: favoritesService.currentFavorite?.label };

<!--
  disabledInteractive keeps the button focusable and hoverable while disabled, so that it
  still exposes its tooltip explaining why it can't be used (saveFavorite discards the click)
-->
<button
  matIconButton
  type="button"
  class="star-button"
  disableRipple
  disabledInteractive
  [disabled]="favoritesService.isSaveDisabled()"
  [matTooltip]="tooltip"
  [attr.aria-label]="tooltip"
  (click)="favoritesService.saveFavorite()"
>
  <mat-icon
    class="star"
    [class.star--active]="favoritesService.currentFavorite !== null"
    [class.star--disabled]="!favoritesService.isSaveAvailable()"
    [class.star--undefined]="favoritesService.currentFavorite === null && favoritesService.isSaveAvailable()"
  >
    star
  </mat-icon>
</button>
